import fr from 'facet-rest';
import React from 'react';
import PropTypes from 'prop-types';
import ManagedAccountDisclaimersMessage from './ManagedAccountConsentMessage/ManagedAccountConsentMessage';

const ManagedAccountDisclaimersMessagePicker = ({ resource }) => {
  return resource.withRelationship(
    fr.relationships.managedAccountConsentMessage.name,
    (rel) => (
      <ManagedAccountDisclaimersMessage relationship={rel.link('related')} />
    ),
    () => null,
  );
};

ManagedAccountDisclaimersMessagePicker.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};
ManagedAccountDisclaimersMessagePicker.defaultProps = {
};

export default ManagedAccountDisclaimersMessagePicker;
